export function detectTrackPad(e: WheelEvent) {
	if (e.wheelDeltaY) {
		if (e.wheelDeltaY === e.deltaY * -3) {
			return true
		}
	} else if (e.deltaMode === 0) {
		return true
	}

	return false
}
